import { render } from "./ServicoAbertoLandingPage.vue?vue&type=template&id=105ea373&scoped=true"
import script from "./ServicoAbertoLandingPage.vue?vue&type=script&lang=js"
export * from "./ServicoAbertoLandingPage.vue?vue&type=script&lang=js"

import "./ServicoAbertoLandingPage.vue?vue&type=style&index=0&id=105ea373&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105ea373"]])

export default __exports__